import { NavItem } from '../interfaces/navitem.interface';

export const NAV_ITEMS: NavItem[] = [
  { label: '좋은공간 소개', path: '/about' },
  { label: '공지사항', path: '/notice' },
  { label: '기부사랑', path: '/donation' },
  { label: '제휴문의', path: '/inquiry' },
];
